import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router';
import {
    BlogRelatedPost,
    BlogRelatedPostImage,
    BlogRelatedPostMain,
    BlogRelatedPostTitle,
    BlogRelatedTitle,
} from './styles';
import URLUtils from '../../../util/URLUtils';

interface RelatedBlogPost {
    id?: string;
    featuredImage?: string;
    name?: string;
}

interface RelatedBlogProps {
    relatedBlogs: RelatedBlogPost[];
}

const RelatedBlogs = ({ relatedBlogs }: RelatedBlogProps) => {
    const navigate = useNavigate();

    return (
        <Box component='section'>
            <BlogRelatedTitle variant='h6'>Related posts</BlogRelatedTitle>
            <BlogRelatedPost>
                {relatedBlogs.length > 0 && relatedBlogs.map((item, inx) => (
                    <BlogRelatedPostMain key={item.id || inx} onClick={() => navigate(`/blog/${item?.id}`)}>
                        <BlogRelatedPostImage
                            src={item?.featuredImage ?? '/app-images/not-found-image/place_holder_image.png'}
                            alt='Related Post'
                        />
                        <BlogRelatedPostTitle to={`/blog/${item?.id}/${URLUtils.formatEncodePath(item?.name ?? '')}`}>
                            {item?.name}
                        </BlogRelatedPostTitle>
                    </BlogRelatedPostMain>
                ))}
            </BlogRelatedPost>
        </Box>
    );
};

export default RelatedBlogs;

